import React from "react";
import { User } from "@auth0/auth0-react";

type AuthCtxType = {
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: User;
  logout: () => Promise<void>;
};

export const AuthCtx = React.createContext<AuthCtxType>({
  isAuthenticated: false,
  isLoading: true,
  logout: async () => {
    throw new Error("Not implemented");
  },
});
